import React from "react"
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom"
import { AgreementRouter } from "./AgreementRouter"

interface AppRouterProps {
    config: any
}

export const AppRouter: React.FC<AppRouterProps> = ({config}) => {

    

    return (
        <>
            <Router>
                <Route path={"/"} exact>
                    <Redirect to={`/bd601f4d-adb8-03a3-d6d4-b83c273a968e`} />
                </Route>
                <Route path="/:agreementId">
                    <AgreementRouter loginUrl={config.loginUrl} apiBaseUrl={config.apiUrl}/>
                </Route>
            </Router>
        </>
    )
}

// 8356308c-818e-d5e6-b082-f25ebd1eac91